const FREE_SHIPPING_TARGET = window.MI_FREE_SHIPPING || 15000;
const CART_LINES_UPDATE_EVENT = 'shopify:cart:lines-update';
const CART_ERROR_EVENT = 'shopify:cart:error';
let toastTimer;

function createDeferred() {
  let resolve;
  let reject;
  const promise = new Promise((onResolve, onReject) => {
    resolve = onResolve;
    reject = onReject;
  });
  return { promise, resolve, reject };
}

function createCartEvent(payload) {
  const event = new Event(CART_LINES_UPDATE_EVENT, { bubbles: true });
  Object.assign(event, payload);
  return event;
}

function createStandardCart(cart) {
  return {
    id: cart.token || 'cart',
    totalQuantity: Number(cart.item_count || 0),
    cost: {
      totalAmount: {
        amount: String(Number(cart.total_price || 0) / 100),
        currencyCode: cart.currency || 'SAR',
      },
    },
    lines: (cart.items || []).map((item) => ({
      id: item.key || item.id,
      quantity: item.quantity,
      cost: {
        totalAmount: {
          amount: String(Number(item.final_line_price || item.line_price || 0) / 100),
          currencyCode: cart.currency || 'SAR',
        },
      },
    })),
    discountCodes: [],
  };
}

function formatMoney(cents) {
  return new Intl.NumberFormat('ar-SA-u-nu-latn', {
    style: 'currency',
    currency: 'SAR',
    maximumFractionDigits: 0,
  }).format(Math.max(0, cents) / 100);
}

function showCartToast(cart) {
  let toast = document.querySelector('[data-mi-cart-toast]');
  if (!toast) {
    toast = document.createElement('div');
    toast.className = 'mi-cart-toast';
    toast.dataset.miCartToast = '';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML = '<span class="mi-cart-toast__icon" aria-hidden="true"><span class="mi-fa mi-fa--shipping-fast">&#xf48b;</span></span><span class="mi-cart-toast__copy"><strong></strong><small></small></span>';
    document.body.append(toast);
  }

  const remaining = Math.max(0, FREE_SHIPPING_TARGET - Number(cart.total_price || 0));
  toast.querySelector('strong').textContent = 'تمت إضافة المنتج إلى السلة';
  toast.querySelector('small').textContent = remaining > 0
    ? `باقي ${formatMoney(remaining)} وتحصل على شحن مجاني`
    : 'مبروك، طلبك مؤهل للشحن المجاني';
  toast.classList.add('is-visible');
  clearTimeout(toastTimer);
  toastTimer = window.setTimeout(() => toast.classList.remove('is-visible'), 4200);
}

async function addCardProduct(form) {
  const button = form.querySelector('button[type="submit"]');
  if (!button || button.disabled || button.getAttribute('aria-busy') === 'true') return;

  const formData = new FormData(form);
  const variantId = String(formData.get('id') || '');
  const quantity = Number(formData.get('quantity')) || 1;
  const sectionIds = [...document.querySelectorAll('cart-items-component[data-section-id]')]
    .map((element) => element.dataset.sectionId)
    .filter(Boolean);
  if (sectionIds.length) formData.set('sections', [...new Set(sectionIds)].join(','));
  formData.set('sections_url', window.location.pathname);

  const deferred = createDeferred();
  form.dispatchEvent(createCartEvent({
    action: 'add',
    context: 'product',
    lines: [{ merchandiseId: variantId, quantity }],
    promise: deferred.promise,
  }));

  const originalMarkup = button.innerHTML;
  button.setAttribute('aria-busy', 'true');
  button.disabled = true;
  button.textContent = 'جاري الإضافة…';

  try {
    const response = await fetch(form.action || Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    });
    const payload = await response.json();
    if (!response.ok || payload.status) throw new Error(payload.description || payload.message || 'تعذرت إضافة المنتج');

    const cartResponse = await fetch(`${Theme.routes.cart_url}.json`, { headers: { Accept: 'application/json' } });
    if (!cartResponse.ok) throw new Error('تعذر تحديث السلة');
    const cart = await cartResponse.json();
    deferred.resolve({
      cart: createStandardCart(cart),
      detail: {
        items: cart.items,
        source: 'made-in-card-form',
        itemCount: quantity,
        sections: payload.sections,
        rawCart: cart,
        didError: false,
      },
    });
    button.textContent = 'تمت الإضافة';
  } catch (error) {
    deferred.reject(error);
    const cartError = new Event(CART_ERROR_EVENT, { bubbles: true });
    Object.assign(cartError, { error: error.message || 'تعذرت إضافة المنتج', code: 'INVALID' });
    form.dispatchEvent(cartError);
    button.textContent = 'حاول مرة أخرى';
  } finally {
    window.setTimeout(() => {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.innerHTML = originalMarkup;
    }, 1100);
  }
}

document.addEventListener('submit', (event) => {
  const form = event.target instanceof Element ? event.target.closest('[data-made-card-form]') : null;
  if (!(form instanceof HTMLFormElement)) return;
  event.preventDefault();
  addCardProduct(form);
}, true);

document.addEventListener(CART_LINES_UPDATE_EVENT, (event) => {
  if (event.action !== 'add' || !event.promise) return;
  event.promise
    .then(async ({ detail }) => {
      if (detail?.didError) return;
      if (detail?.rawCart) {
        showCartToast(detail.rawCart);
        return;
      }
      const response = await fetch(`${Theme.routes.cart_url}.json`, { headers: { Accept: 'application/json' } });
      if (response.ok) showCartToast(await response.json());
    })
    .catch(() => {});
});

document.documentElement.dataset.miCommerceReady = 'true';
